import React, { ReactElement } from "react";
import { TimelineGroupsProps } from "./TimelineGroups.types";
import { TimelineGroup } from "../TimelineGroup";
import { plannerStyling } from "../utils";

function TimelineGroups({
    axisWidth,
    totalWidth,
    groups,
    onBarClick,
    onBarGroupClick,
    onCategoryUpdate,
    onGroupClick,
    onItemDurationChange,
    onDisplayedItemsChange,
    onRailClick,
    timelineDuration,
    timelineMode,
    timelineSize,
    todayTime,
    positioning,
    headerHeight,
    rights
}: TimelineGroupsProps): ReactElement {
    const groupCount = groups.length;

    return (
        <section className="TimelineGroups" role="rowgroup" style={{ width: totalWidth }}>
            {groups.map((group, index) => {
                const cumulativeIndex = groups
                    .slice(0, index)
                    .reduce((acc, group) => acc + 1 + group.categories.length, 0);

                return (
                    <TimelineGroup
                        axisWidth={axisWidth}
                        displayGroupHeader={groupCount > 1}
                        group={group}
                        hasWriteAccess={rights.editableBoardIds.includes(group.key)}
                        cumulativeIndex={cumulativeIndex}
                        key={group.key}
                        offset={positioning[group.key].topOffset - headerHeight}
                        onBarClick={onBarClick}
                        onBarGroupClick={onBarGroupClick}
                        onCategoryUpdate={onCategoryUpdate}
                        onGroupClick={onGroupClick}
                        onDisplayedItemsChange={onDisplayedItemsChange}
                        onItemDurationChange={onItemDurationChange}
                        onRailClick={onRailClick}
                        timelineDuration={timelineDuration}
                        timelineMode={timelineMode}
                        timelineSize={timelineSize}
                        todayTime={todayTime}
                        positioning={positioning}
                        boardId={Number(group.key)}
                    />
                );
            })}
        </section>
    );
}

export default TimelineGroups;
